module.exports = __webpack_public_path__ + "img/harvest_confirm.7ef37056.svg";